
import { useEffect } from 'react';
import { CampLocation } from '@/types/campLocation';
import { getCampLocationById } from '@/services/campLocationService';
import { db } from '@/services/firebaseService';

interface UseLocationVerificationProps {
  isOpen: boolean;
  location: CampLocation;
}

export const useLocationVerification = ({ isOpen, location }: UseLocationVerificationProps) => {
  useEffect(() => {
    if (!isOpen || process.env.NODE_ENV === 'production') return;
    
    const verifyLocationSource = async () => {
      try {
        // Double check against the database that we're using published data
        const publishedLocation = await getCampLocationById(db, location.id);
        
        // Enhanced verification logging
        if (publishedLocation) {
          const isPassing = publishedLocation.id === location.id && 
                           publishedLocation.visibility === location.visibility &&
                           publishedLocation.visibility === "v_published";
                           
          
          // If we detect a mismatch, log a critical warning
          if (!isPassing) {
            console.error("CRITICAL WARNING: Location used in dialog does NOT match the published location!");
          }
        }
      } catch (error) {
        console.error("Error verifying location source:", error);
      }
    };
    
    verifyLocationSource();
  }, [isOpen, location.id, location.visibility]);
};
